/* Amend to add related:true Mar 9, 2025  */
<template lang="pug">
	div(class="kt-related")
		b-card(v-for="(rg, ix) in d_relatedGrids" :key="ix" no-body)
			b-card-header() 
				span {{rg.headerLabel}}
				b-button-group(v-if="rg.filters.length>1")
					span(v-for="(f,ixf) in rg.filters" :key="ixf"
						class="btn btn-outline-secondary" 
						:class="f.selected?'active':null"
						@click="rg.fn_filterChange($event, f, m_ktt(rg))"
						) {{f.label}}
			b-card-body 
				kt-table(:ref="rg.refKey"
					:p_appEntKey="rg.appEntKeyRelated"
					:p_tblIdKey="rg.tblIdKey"
					:p_opts="c_ktOptions"
					:p_cols="rg.cols" 
					:p_qryPrms="rg.queryParams"
					:p_tbNote="rg.toolbarText"
				)
</template>

 <script>
import {fn_appEnt} from "@/utils/ref-data.js";
import {fn_taskCol_ActivityScope} from "@/utils/util.js";
import KTTable from "@/components/Ctrl/KT-Table.vue";

import {fn_getColumns as fn_getColumnsOppr} from "@/components/Nav/OpprNav.vue";
import {fn_getColumns as fn_getColumnsProj} from "@/components/Nav/ProjNav.vue";
import {fn_getColumns as fn_getColumnsAcct} from "@/components/Nav/AcctNav.vue";
import {fn_getColumns as fn_getColumnsTask} from "@/components/Ctrl/KT-Tasks.vue";

const getColFns = {
	oppr: fn_getColumnsOppr,
	proj: fn_getColumnsProj,
	acct: fn_getColumnsAcct,
	task: fn_getColumnsTask,
};

export default {
	name: "kt-related",
	components: {
		'kt-table': KTTable
	},
	created() {},
	mounted() {},
	data() {
		return {
			d_relatedGrids: this.p_relatedGrids
		};
	},
	props: {
		p_relatedGrids: Array,
	},
	computed: {
		c_ktOptions() {
			return {
				detailView: false,
				maxHeight: 360,
				// staticHeight:100,
				pageSize: 10,
				enableSearch: false,
				enableCUFilter: false,
				openLinksInModal: true,
			};
		},
	},
	methods: {
		m_ktt(rg) {
			return this.$refs[rg.refKey][0];
		}
	},
	watch: {}
};
export {RelatedGridClass, getColFns};

class RelatedGridClass {
	constructor (appEntKey, recId, recNm, appEntKeyRelated, fn_getColumns, filters) {

		this.appEntIdKey = fn_appEnt(appEntKey).idKey;
		this.recId = recId;
		this.recNm = recNm;
		this.appEntKeyRelated = appEntKeyRelated;
		this.refKey = `kt-table-${appEntKeyRelated}-${appEntKey}-rr`;
		this.tblIdKey = `-${appEntKey}-rr`;
		this.headerLabel = fn_appEnt(appEntKeyRelated).label;
		this.cols = fn_getColumns();
		this.filters = filters;
		this.queryParams = {[this.appEntIdKey]: this.recId, related:true};

		this.toolbarText = this.fn_toolbarText();

		this.filters.forEach(x => x.selected = false);

		if (appEntKeyRelated == 'task') {
			this.cols.forEach(x => {
				x.field = x.key;
				if (x.editOnClick) {
					x.linkFn = (col, row) => {return {prntType: row.prntType, id: row.taskId};};
				}
				if (x.key == 'taskChecklist') x.noToggle = true;
				['key', '__dbvw', 'hideInForm', 'icon', 'iconFn', 'editOnClick'].forEach(k => delete x[k]);
			});

			this.cols.unshift(fn_taskCol_ActivityScope());
		}

	}

	fn_filterChange(e, f, tbl) {
		if (e.detail > 1) return;
		this.filters.forEach(x => x.selected = (x.key != f.key ? false : !f.selected));

		this.queryParams = f.selected ? {[f.paramNm]: this.recId, related:true} : {[this.appEntIdKey]: this.recId, related:true};
		this.toolbarText = this.fn_toolbarText(f);
	}

	fn_toolbarText(f) {
		let filterLabel = (f && f.selected) ? `"${f.label}"` : this.filters.map(x => `"${x.label}"`).join(' or ');
		let an = /[AEIOU]/.test(filterLabel[1]) ? 'an' : 'a';
		return `${this.headerLabel} where "${this.recNm}" is ${an} ${filterLabel}`;
	}

	fn_noValueAggr() {
		let col = this.cols.filter(x => x.field == 'value')[0];
		if (col) delete col.showAggr;
	}

}
</script>

<style lang="less">
</style>

